import { z } from 'zod'

export const voucherStateValues = ['open', 'redeemed', 'expired'] as const
export type VoucherState = (typeof voucherStateValues)[number]

/** A prize won in a daily drop, redeemed once at the place by a staff swipe. */
export const voucherDtoSchema = z.object({
  id: z.string().uuid(),
  dropId: z.string().uuid(),
  code: z.string(),
  prizeName: z.string(),
  /** How to redeem it, as the admin wrote it ("Ein Getränk nach Wahl bis 5 €"). */
  note: z.string(),
  placeName: z.string().nullable(),
  placeAddress: z.string().nullable(),
  listingId: z.string().uuid().nullable(),
  validUntil: z.string(),
  redeemedAt: z.string().nullable(),
  createdAt: z.string(),
})
export type VoucherDto = z.infer<typeof voucherDtoSchema>

export const voucherResponseSchema = z.object({ voucher: voucherDtoSchema })
export type VoucherResponse = z.infer<typeof voucherResponseSchema>

/** What the Pulsify message that delivers a voucher stores for its chat card. */
export const dropVoucherMessageMetadataSchema = z.object({
  voucherId: z.string().uuid(),
  dropId: z.string().uuid(),
  code: z.string(),
  prizeName: z.string(),
  placeName: z.string().nullable(),
  validUntil: z.string(),
})
export type DropVoucherMessageMetadata = z.infer<typeof dropVoucherMessageMetadataSchema>

/** Open until it is redeemed or its date has passed. */
export function voucherState(
  voucher: Pick<VoucherDto, 'redeemedAt' | 'validUntil'>,
  now: Date,
): VoucherState {
  if (voucher.redeemedAt) return 'redeemed'
  return new Date(voucher.validUntil).getTime() > now.getTime() ? 'open' : 'expired'
}
